module.exports = __webpack_public_path__ + "img/profile-top-light.f40ae15.png";